import { DateTimePicker } from '@mui/x-date-pickers';
import { useController } from 'react-hook-form';

export function DateTimePickerController({
  name,
  control,
  disabled,
  rules,
  label,
  minDate,
  maxDate,
  sx,
  exclude,
}) {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
    rules,
    disabled: exclude,
  });

  return (
    <DateTimePicker
      inputRef={ref}
      value={value ?? null}
      onChange={onChange}
      disabled={disabled}
      label={label}
      minDate={minDate}
      maxDate={maxDate}
      ampm={false}
      sx={{ minWidth: 240, ...sx }}
      slotProps={{
        textField: {
          size: 'small',
          error: invalid,
          helperText: error?.message,
          onBlur,
        },
      }}
    />
  );
}
